import { createI18n } from 'vue-i18n'
import { getMessages } from './composables/useLocale'

const datetimeFormats = {
  'en-GB': {
    short: { year: 'numeric', day: '2-digit', month: '2-digit' }
  },
  de: {
    short: { year: 'numeric', day: '2-digit', month: '2-digit' }
  }
}

const [language] = navigator.language.split('-')

const i18n = createI18n({
  legacy: false, // comp api instead of legacy
  locale: navigator.language, // default locale. Pull from database if exists?
  fallbackLocale: [language, 'en-GB', 'en'],
  silentFallbackWarn: true, // keeps console log clean
  messages: getMessages(),
  fallbackWarn: false,
  warnHtmlMessage: false,
  missingWarn: false,
  datetimeFormats
})

export default i18n
